export const SITE_VIEWPORT_SIZE_PRESETS = {
  sm: {
    height: '667px',
    width: '375px',
  },
  md: {
    height: '1024px',
    width: '768px',
  },
  lg: {
    height: '100%', // TODO:.... these probably aren't right now
    width: '100%',
  },
};
